import React from 'react'
import { Tooltip } from '@mui/material'
import { newConnection, setConnection } from '../helpers/connectionHelper'
import { InlineTextFieldSetting } from './InlineTextFieldSetting'
import { DEFAULT_CONNECTION } from '@common/constants'
import { REGEX_CHARACTERS } from '../constants'
import { Icon } from './Icon'

const PUBLIC_TIMEOUT = 15

export const TimeoutSetting: React.FC<{ service: IService; connection?: IConnection }> = ({ service, connection }) => {
  if (!service) return null
  if (!connection) connection = newConnection(service)
  if (connection.timeout === undefined) connection.timeout = DEFAULT_CONNECTION.timeout

  const disabled = connection.connected || connection.public
  const timeout = connection.public ? PUBLIC_TIMEOUT : connection.timeout
  let display = timeout === 0 ? 'Never' : `${timeout} minutes`

  const save = (newTimeout?: number) =>
    connection &&
    setConnection({
      ...connection,
      timeout: newTimeout,
    })

  return (
    <InlineTextFieldSetting
      value={timeout}
      modified={timeout !== DEFAULT_CONNECTION.timeout}
      filter={REGEX_CHARACTERS}
      displayValue={display}
      icon="hourglass"
      label={
        <>
          Idle Timeout
          <Tooltip
            title={
              <>
                Time until connection is closed and returns to waiting state.
                <br />
                Enter zero (0) for persistent connections.
              </>
            }
            placement="top"
            arrow
          >
            <span style={{ zIndex: 10 }}>
              <Icon name="question-circle" size="sm" inline />
            </span>
          </Tooltip>
        </>
      }
      disabled={disabled}
      resetValue={DEFAULT_CONNECTION.timeout}
      onSave={timeout => save(+timeout)}
    />
  )
}
